import React from 'react';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

export default class Chef extends PositionedGoodyHOC {
	// 4
	render() {
		const style = {
			st2: {
				fill: '#FFFFFF',
			},
			st33: {
				fill: '#E5E5E5',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} style={style.st144} cx="52.2152481" cy="92.0450745" />
				<path style={style.st2} d="M86.4273453,52.695034H19.5726528v36.0097618c0,1.3227463,0.9325886,2.4620743,2.2292576,2.7234344
					l2.4605579,0.4959717c19.8100071,3.9930267,40.232933,3.8333817,59.978096-0.4688416l0.0000305-0.0000076
					c1.2765045-0.2781296,2.1867523-1.4080734,2.1867523-2.7145233V52.695034z" />
				<ellipse style={style.st2} cx="53" cy="32.195034" rx="52.8375053" ry="32" />
				<path style={style.st33} d="M79.5607529,41.5504265c-2.5407181,5.2112732-0.5708313,14.6979408-0.5708313,14.6979408
					s8.6870651-4.290947,11.2277832-9.5022202s0.9158096-7.9347038-2.0270309-9.3694611
					C85.2478409,35.941925,82.1014709,36.3391571,79.5607529,41.5504265z" />
				<path style={style.st33} d="M63.0960541,46.1276283c-0.773674,4.3453293,2.6466599,10.8805199,2.6466599,10.8805199
					s5.4657822-4.9530411,6.2394562-9.2983704s-0.983902-6.0005608-3.4377365-6.437458
					C66.0906067,40.8354187,63.8697281,41.782299,63.0960541,46.1276283z" />
				<path style={style.st33} d="M48.7336769,48.1896362c0.0348244,4.2971573,4.474659,9.9419861,4.474659,9.9419861
					s4.3477707-5.7160416,4.3129463-10.0131989s-2.0124207-5.567852-4.4390526-5.5481873
					C50.6556015,42.589901,48.6988525,43.8924751,48.7336769,48.1896362z" />
				<path style={style.st33} d="M25.8982258,41.5504265c2.54072,5.2112732,0.5708351,14.6979408,0.5708351,14.6979408
					s-8.6870651-4.290947-11.2277832-9.5022202s-0.9158087-7.9347038,2.0270271-9.3694611
					C20.2111397,35.941925,23.3575077,36.3391571,25.8982258,41.5504265z" />
				<path style={style.st33} d="M42.3629265,46.1276283c0.773674,4.3453293-2.6466599,10.8805199-2.6466599,10.8805199
					s-5.4657822-4.9530411-6.2394562-9.2983704s0.983902-6.0005608,3.4377327-6.437458
					C39.3683777,40.8354187,41.5892525,41.782299,42.3629265,46.1276283z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/Chef.js